import { CloudRepository } from './cloud-repository';
import { LocalRepository } from './local-repository';
import type { Repository } from './repository';

let instance: Repository | null = null;
let currentMode: 'local' | 'cloud' = 'local';

export function createRepository(mode: 'local' | 'cloud'): Repository {
  if (mode === 'cloud') return new CloudRepository();
  return new LocalRepository();
}

export function getRepository(): Repository {
  if (!instance) {
    instance = createRepository(currentMode);
  }
  return instance;
}

export function setRepositoryMode(mode: 'local' | 'cloud'): void {
  if (mode !== currentMode) {
    currentMode = mode;
    instance = null;
  }
}
